import { m } from 'motion/react';
import { useState } from 'react';
import { itemVariants } from '../../../utils/framer';
import Snippet from '../../components/Snippet';
import { ImageTypeEnum } from '../../components/carousel/types/CarouselTypes';
import GreyListbox from '../../components/newKiaEV6/GreyListBox';
import InfoBoxImgTextLinks from '../../components/newKiaEV6/InfoBoxImgTextLinks';
import InfoBoxesSection from '../../components/newKiaEV6/InfoBoxSection';
import AnimatedSection from '../../components/privatleasing/AnimatedSection';
import { TextBox } from '../../components/privatleasing/TextBox';
import { TwoFlexibleComponentBox } from '../../components/rentAndShare/TwoFlexibleComponentBox';
import { VideoClip } from '../../components/rentAndShare/VideoClip';
import LinkButton from '../../components/ui/LinkButton';
import KIAImage from '../../components/ui/image/KIAImage';
import PriceCardGrid from '../cardgrid/cardgrid';
import {
  greyListData,
  headingEV6,
  heroev6,
  infobox01,
  infobox02,
  infobox03,
  infobox04,
  infobox05,
  infobox06,
  infobox07,
  infobox09,
  kiaImageEV601,
  kiaImageEV602,
  kiaImageEV603,
  kiaImageEV605,
  linkEV601,
  linkEV602,
  linkEV604,
  textBox2,
  textBoxicon01,
  twoComponentsTextEV601,
  twoComponentsTextEV602,
  twoComponentsTextEV604,
} from './newKiaEv6-copy';

const NewKiaEV6 = () => {
  const [hideControls] = useState(true);

  return (
    <main className="relative">
      <VideoClip autoplay {...heroev6} />
      <div className="w-full max-w-screen-kia mx-auto">
        <AnimatedSection id="hedings" className="mt-9 p-6">
          <m.h2
            className="text-center font-medium text-[30px]  md:text-[40px] leading-[48px] mb-1 "
            variants={itemVariants}
          >
            {headingEV6.heading}
          </m.h2>
          <m.p
            variants={itemVariants}
            className="text-center font-normal text-[17px]  "
          >
            {headingEV6.headingSub}
          </m.p>
        </AnimatedSection>

        <section className="w-full max-w-screen-kia-sm mx-auto">
          <section>
            <TextBox {...textBoxicon01} />
          </section>

          <PriceCardGrid
            hideControls={hideControls}
            modelCodes="ASW5"
            trimCodes="ASW5YCZ7ZKK0JP"
            imageType={'Studiobild' as ImageTypeEnum}
            fields="Byt trim,Businesslease,Förmånsvärde,Frånpris,Upptäck bilen,Kontakta återförsäljare"
          />
        </section>
        <section className=" mx-auto px-6 w-full max-w-7xl  mb-5">
          <TwoFlexibleComponentBox
            firstComponentWidth="col-span-4 lg:col-span-5"
            secondComponentWidth="col-span-4 lg:col-span-3"
            mainBoxClassName="mx-auto w-full max-w-7xl"
            firstComponentClassName="p-0"
            secondComponentClassName="p-0 lg:p-10 lg:pt-0"
            mobilFirstComponentOnTop={false}
            desktopFirstComponentFirst={true}
            firstComponent={<KIAImage {...kiaImageEV601} />}
            secondComponent={
              <div>
                <h3 className="text-[23px] md:text-[32px] leading-[40px] mb-4">
                  {twoComponentsTextEV601.title}
                </h3>
                <p className="text-[16px] md:text[18px] leading-[24px] font-light">
                  {twoComponentsTextEV601.text}
                </p>
                <div className="flex justify-center md:justify-start">
                  <LinkButton {...linkEV601} />
                </div>
              </div>
            }
          />
        </section>
        <section className=" mx-auto px-6 w-full max-w-7xl  mb-5">
          <TwoFlexibleComponentBox
            firstComponentWidth="col-span-4 lg:col-span-3"
            secondComponentWidth="col-span-4 lg:col-span-5"
            mainBoxClassName="mx-auto w-full max-w-7xl"
            firstComponentClassName="p-0 lg:p-10 lg:pt-0"
            secondComponentClassName="p-0"
            mobilFirstComponentOnTop={true}
            desktopFirstComponentFirst={true}
            firstComponent={
              <div>
                <h3 className="text-[23px] md:text-[32px] leading-[40px] mb-4">
                  {twoComponentsTextEV602.title}
                </h3>
                <p className="text-[16px] md:text[18px] leading-[24px] font-light">
                  {twoComponentsTextEV602.text}
                </p>
                <div className="flex justify-center md:justify-start">
                  <LinkButton {...linkEV602} />
                </div>
              </div>
            }
            secondComponent={<KIAImage {...kiaImageEV602} />}
          />
        </section>
        <section>
          <TextBox {...textBox2} />
        </section>
         <section className=" mx-auto px-6 w-full max-w-7xl  mb-5">
          <TwoFlexibleComponentBox
            firstComponentWidth="col-span-4 lg:col-span-5"
            secondComponentWidth="col-span-4 lg:col-span-3"
            mainBoxClassName="mx-auto w-full max-w-7xl"
            firstComponentClassName="p-0"
            secondComponentClassName="p-0 lg:p-10 lg:pt-0"
            mobilFirstComponentOnTop={true}
            desktopFirstComponentFirst={true}
            firstComponent={<KIAImage {...kiaImageEV605} />}
            secondComponent={
              <div>
                <h3 className="text-[23px] md:text-[32px] leading-[40px] mb-4">
                  {twoComponentsTextEV604.title}
                </h3>
                <p className="text-[16px] md:text[18px] leading-[24px] font-light">
                  {twoComponentsTextEV604.text}
                </p>
                <div className="flex justify-center md:justify-start">
                  <LinkButton {...linkEV604} />
                </div>
              </div>
            }
          />
        </section>
        <section className=" mx-auto px-6 w-full max-w-7xl  mb-16">
          <InfoBoxImgTextLinks {...infobox01} />
        </section>
        
        <section className="max-w-screen-kia mb-20">
          <AnimatedSection id="kia-img" className="mt-0">
            <m.div variants={itemVariants}>
              <KIAImage {...kiaImageEV603} />
            </m.div>
          </AnimatedSection>
        </section>
        <section className=" mx-auto px-6 w-full max-w-7xl  mb-16">
          <InfoBoxImgTextLinks {...infobox02} />
        </section>
        <section className=" mx-auto px-6 w-full max-w-7xl  mb-16">
          <InfoBoxesSection
            boxes={[infobox03, infobox04, infobox05]}
            columns={3}
            containerClassName="px-0"
          />
        </section>
        <section className=" mx-auto px-6 w-full max-w-7xl  mb-16">
          <GreyListbox {...greyListData} />
        </section>
        <section className=" mx-auto px-6 w-full max-w-7xl mb-10 md:mb-20">
          <InfoBoxesSection
            boxes={[infobox06, infobox07, infobox09]}
            columns={3}
            containerClassName="px-0 "
          />
        </section>
        <Snippet page="new-kia-ev6" />
      </div>
    </main>
  );
};

export default NewKiaEV6;
